import Vue from 'vue';
import VueRouter from 'vue-router';
import { authMeta, eventMeta } from './meta';

// META
import Meta from 'vue-meta';

// STORE
import store from '@/store';

Vue.use(Meta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-ssr',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
});

import scrollBehavior from './scroll-behavior';

// TOKEN
import { TokenService } from '@/services/token';

// Utilities
import { layout, root, route, subRoute, trailingSlash } from './utils';

Vue.use(VueRouter);

const event = ':year?/:month?/:day?/:hour?/:minute?/:second?';

const routes = root([
  layout('auth', 'Auth', [
    route('', 'Auth', [
      subRoute(
        'email-confirm',
        'email-confirm',
        'components/auth/EmailConfirm'
      ),
      subRoute('sign-in', 'sign-in', 'components/auth/SignInWizard'),
      subRoute('sign-up', 'sign-up', 'components/auth/SignUpWizard'),
      subRoute(
        'password-reset',
        'password-reset',
        'components/auth/PasswordReset'
      ),
      subRoute(
        'v1/accounts/auth/password-reset/confirm/:uid?/:token?/',
        'password-reset-confirm',
        'components/auth/PasswordResetConfirm'
      ),
      {
        path:
          '/v1/eventcal/calendars/:calendarId/events/:eventId/(occurrences)?/:occurrenceId?/token/:token/rsvp/:rsvp/',
        redirect: { name: 'calendar-event-page' }
      },
      subRoute(
        '/calendar/:calendarId/events/:eventId/(occurrences)?/:occurrenceId?/token/:token/rsvp/:rsvp/',
        'calendar-event-page',
        'components/data/calendar/EventPage'
      )
    ])
  ]),
  // choose to add router-views
  // layout('', 'home', [route('', 'home', undefined, authMeta)]),
  layout('', 'home', [route('', 'select', undefined, { ...authMeta })]),

  layout('', 'app', [
    route(
      'settings/',
      'settings',
      [
        subRoute(
          'integrations',
          'settings-integrations',
          'views/settings/integrations', [], undefined, { label: 'integrations' }
        ),
        subRoute('general', 'tasks-settings-general', 'views/settings/tasksgeneral', [], undefined, { label: 'general' }),
        subRoute('tasks-management', 'tasks-settings-management', 'views/settings/taskmanagement', [], undefined, { label: 'tasks' }),
        subRoute('profile', 'settings-profile', 'views/settings/profile', [], undefined, { label: 'profile' })
      ],
      { ...authMeta, ...eventMeta },
      { name: 'settings-integrations' }
    ),
    route(
      'tasks',
      'tasks',
      [
        subRoute('board', 'tasks-board', 'views/tasks/board'),
        // subRoute('settings', 'tasks-settings', 'views/tasks/settings/index', [

        // ], { name: 'tasks-settings-general' }, { label: 'settings' })
      ],
      { ...authMeta, ...eventMeta },
      { name: 'tasks-board' }
    ),
    route('notify', 'notifications', [], { ...authMeta, ...eventMeta }),
    route(
      'calendar',
      'calendar',
      [subRoute('r', 'calendar-detail', 'components/data/calendar/Index')],
      { ...authMeta, ...eventMeta },
      { name: 'calendar-detail' }
    ),
    route('overview', 'overview', [], { ...authMeta, ...eventMeta }),
    route('getting-started', 'getting-started', [], {
      ...authMeta,
      ...eventMeta
    }),
    route(
      'addressbook',
      'addressbook',
      // 'views/app/addressbook/Index',
      [
        subRoute('contacts', 'contacts', 'views/addressbook/contacts/Index', [
          subRoute(
            'list',
            'contact-list',
            'views/addressbook/contacts/ContactList'
          ),
          subRoute(
            ':contactId?',
            'contact-detail',
            'views/addressbook/contacts/ContactDetail'
          )
        ]),
        subRoute(
          'companies',
          'companies',
          'views/addressbook/companies/Index',
          [
            subRoute(
              'list',
              'company-list',
              'views/addressbook/companies/CompanyList'
            ),
            subRoute(
              ':companyId?',
              'company-detail',
              'views/addressbook/companies/CompanyDetail'
            )
          ]
        )
      ],
      { ...authMeta, ...eventMeta }
      // { name: 'contacts-list' },
    ),
    route(
      'app',
      'app',
      [
        subRoute(
          'event/',
          'event',
          'views/app/event/Index',
          [subRoute(':id?', 'event-detail', 'views/app/event/Detail')],
          { name: 'event-detail' }
        ),
        subRoute(
          'news',
          'news',
          'views/app/news/Index',
          [
            subRoute('list', 'news-list', 'views/app/news/List'),
            subRoute(':id', 'news-detail', 'views/app/news/Detail')
          ],
          { name: 'news-list' }
        ),
        subRoute(
          'speaker',
          'speaker',
          'views/app/speaker/Index',
          [
            subRoute('list', 'speaker-list', 'views/app/speaker/SpeakerList'),
            subRoute(
              'create',
              'speaker-create',
              'views/app/speaker/SpeakerCreate'
            ),
            subRoute(
              ':speakerId',
              'speaker-detail',
              'views/app/speaker/SpeakerDetail'
            )
          ],
          { name: 'speaker-list' }
        ),
        subRoute(
          'sponsor',
          'sponsor',
          'views/app/sponsor/Index',
          [
            subRoute('list', 'sponsor-list', 'views/app/sponsor/SponsorList'),
            subRoute(
              'categories',
              'sponsor-categories',
              'views/app/sponsor/SponsorCategories'
            ),
            subRoute(
              ':sponsorId',
              'sponsor-detail',
              'views/app/sponsor/SponsorDetail'
            )
          ],
          { name: 'sponsor-list' }
        ),
        subRoute('session', 'session', 'views/app/session/Index', []),
        subRoute(
          'exhibitor',
          'exhibitor',
          'views/app/exhibitor/Index',
          [
            subRoute(
              'list',
              'exhibitor-list',
              'views/app/exhibitor/ExhibitorList'
            ),
            subRoute(
              'categories',
              'exhibitor-categories',
              'views/app/exhibitor/ExhibitorCategories'
            ),
            subRoute(
              ':exhibitorId',
              'exhibitor-detail',
              'views/app/exhibitor/ExhibitorDetail'
            )
          ],
          { name: 'exhibitor-list' }
        )
      ],
      { ...authMeta, ...eventMeta }
    )
  ])
]);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
});

const tokenService = new TokenService();

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresEvent = to.matched.some(record => record.meta.requiresEvent);

  const currentEvent = localStorage.getItem('current__event');

  const loggedIn = () => {
    try {
      return (
        !!tokenService.isExpired(
          JSON.parse(localStorage.getItem('user') || '').exp
        ) && localStorage.getItem('user')
      );
    } catch (e) {
      return false;
    }
  };
  if (requiresAuth) {
    // console.log(loggedIn() && requiresEvent && !currentEvent);

    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!loggedIn()) {
      next({
        name: 'sign-in',
        query: { redirect: to.name }
      });
    } else if (loggedIn() && requiresEvent && !currentEvent) {
      next({
        name: 'select',
        query: { redirect: to.name }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

// router.beforeEach((to, from, next) => {
//   return to.path.endsWith('/') ? next() : next(trailingSlash(to.path));
// });

export default router;
